import type { SectionsMigrationScope as Scope } from '../scope';
import { sections as sectionsUtils } from '@/util';

export const getMigrationSkipCount = (scope: Scope) => {
  return (
    sectionsUtils.getSiteSectionsEditorData(scope.editorAPI)
      ?.migrationSkipCount || 0
  );
};
